import { Navigate, useLocation } from 'react-router-dom';

/**
 * Protects a route by checking for a valid session in localStorage.
 * Redirects to /auth with the intended destination saved in state
 * so the user lands back after login.
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem('accessToken');
  const user  = localStorage.getItem('user');

  if (!token || !user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;